/**
 * Author: Robert Banziziki Muhire
 * Date: 31/03/2020
 *
 */

import { from } from "rxjs";
import { Cookies } from "./Device.interface";
import { map } from "rxjs/operators";
import { buildConsentPreferences, loadConsentPreferences } from "./cookieConsent";


function loadCookiesObservable() {
  return from(loadConsentPreferences()).pipe(
    map((preferences) => {
      const installed = Boolean(preferences);
      const cookiePreferences = preferences
        ? buildConsentPreferences(preferences)
        : undefined;
      const cookieAgreement = Boolean(cookiePreferences);

      return {
        installed,
        cookieAgreement,
        cookiePreferences,
      } as Cookies;
    }),
  );
}

export {
  loadCookiesObservable,
};
